import type { GetBanksResponseDTO } from '~/dto/Assegurou/banks';
import apiAssegurouAuto from '~/services/apiAssegurouAuto';

export async function getBanksUseCase(): Promise<Select.Option[]> {
  try {
    const response = await apiAssegurouAuto.get<GetBanksResponseDTO>(
      `/auto/getListaBancos`
    );

    return response.data.resultData.map((item) => ({
      label: `${item.codigo} - ${item.descricao}`,
      value: String(item.codigo),
    }));
  } catch (error) {
    return [];
  }
}
